import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'game',
	prefix: 'game',
	key: 'game_id',
	fields: {
		game_id: Model.SCHEMA_NUMBER,
		game_ignore: Model.SCHEMA_NUMBER,
		game_sync: Model.SCHEMA_NUMBER,
		game_sync_date: Model.SCHEMA_NUMBER,
		game_type: Model.SCHEMA_NUMBER,
		game_name: Model.SCHEMA_TEXT,
		game_sortname: Model.SCHEMA_TEXT,
		game_avatar: Model.SCHEMA_TEXT,
		game_players_min: Model.SCHEMA_NUMBER,
		game_players_max: Model.SCHEMA_NUMBER,
		game_players_count: Model.SCHEMA_NUMBER,
		game_players_community: Model.SCHEMA_JSON,
		game_players_best: Model.SCHEMA_JSON,
		game_players_recommended: Model.SCHEMA_JSON,
		game_language_count: Model.SCHEMA_NUMBER,
		game_language_dependency: Model.SCHEMA_NUMBER,
		game_language_votes: Model.SCHEMA_JSON,
		game_age_official: Model.SCHEMA_NUMBER,
		game_age_community: Model.SCHEMA_NUMBER,
		game_age_count: Model.SCHEMA_NUMBER,
		game_age_votes: Model.SCHEMA_JSON,
		game_time_min: Model.SCHEMA_NUMBER,
		game_time_max: Model.SCHEMA_NUMBER,
		game_rating_avg: Model.SCHEMA_NUMBER,
		game_rating_count: Model.SCHEMA_NUMBER,
		game_weight_avg: Model.SCHEMA_NUMBER,
		game_weight_count: Model.SCHEMA_NUMBER,
		game_description: Model.SCHEMA_TEXT,
		game_published: Model.SCHEMA_NUMBER,
		game_rank: Model.SCHEMA_NUMBER,
		game_color: Model.SCHEMA_TEXT,
		game_poll_weight: Model.SCHEMA_NUMBER,
		game_poll_language: Model.SCHEMA_NUMBER,
		game_poll_count: Model.SCHEMA_NUMBER,
		game_base: Model.SCHEMA_JSON,
		game_date_avatar: Model.SCHEMA_DATE,
		game_worth_value: Model.SCHEMA_NUMBER,
		game_worth_date: Model.SCHEMA_NUMBER,
		game_worth_count: Model.SCHEMA_NUMBER,
		game_worth_type: Model.SCHEMA_NUMBER,
		game_own: Model.SCHEMA_NUMBER,
		game_contains: Model.SCHEMA_JSON
	},
	methods: {
		to_array: function() {
			return {
				id: this.get_id(),
				name: this.get_name()
			}
		}
	}
})
